import { ServiceDayData } from "./invoicingService-data.model";

export class InvoicingServiceResponse {
  exerciseId: number;
  serviceConceptId: number;
  schoolId: number;
  year: number;
  month: number;
  days: ServiceDayData[]
}

export class InvoicingServicesResponse {
  exerciseId: number;
  year: number;
  month: number;
  schoolId: number;
  servicesConcepts: InvoicingServiceItemResponse[]  
}

export class InvoicingServiceItemResponse {
  serviceConceptId: number;
  serviceDays: ServiceDayData[];
  edited: boolean;
}
